import loadable from '@loadable/component';
export { default as VideoPlayerPlaceholder } from './Placeholder';

export default loadable(() => import(/* webpackChunkName: "pdp-video" */ './Container'));
